import React, { forwardRef, useImperativeHandle, useRef } from "react";
import BillOfMaterialsTable from "./BillOfMaterialsTable";

const BillofMaterials = forwardRef(({
  isEdit,
  formData,
  setFormData,
  bomEntries,
  setBomEntries,
  onBOMChange
}, ref) => {

  const tableRef = useRef()

    useImperativeHandle(ref, () => ({
    resetBOM() {
      tableRef.current.resetEntriesBOMTable(); 
    },
  }));

  const updateBomEntries = (newEntries) => {
    setFormData((prev) => ({ ...prev, bomEntries: newEntries }));
  };
  return (
    <div>
      <BillOfMaterialsTable
      isEdit={isEdit}
        formData={formData}
        setFormData={setFormData}
        bomEntries={bomEntries}
        setBomEntries={setBomEntries}
        onBomEntriesChange={updateBomEntries}
        onEntriesChange={onBOMChange}
        ref={tableRef}
      />
    </div>
  );
});

export default BillofMaterials;
